// src/components/SkillsCard.js
import React from 'react';
import { Grid, TextField, RadioGroup, FormControlLabel, Radio, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SectionCardFactory from '../shared/SectionCardFactory';
import components from '../../../theme/components';

const SkillsCard = SectionCardFactory({
  sectionName: "Skills",
  sectionKey: "skills",
  
  initialItemFields: () => ({
    displayFormat: 'category', // 'category' or 'individual'
    category: '',
    skills: '', // Comma-separated for category format
    skillName: '', // For individual format
    proficiency: '', // For individual format
    expanded: true,
  }),
  
  generateTitle: (item, index, t) => {
    if (item.displayFormat === 'individual') {
      return item.skillName || `${t('inputSection.defaultTitles.skill')} ${index + 1}`;
    }
    return item.category || `${t('inputSection.defaultTitles.skill')} ${index + 1}`;
  },
  
  renderFields: ({ item, handleChange, t }) => {
    // Define proficiency levels with translations
    const SKILL_PROFICIENCY_LEVELS = [
      { value: "Expert", label: t('skills.expert') },
      { value: "Advanced", label: t('skills.advanced') },
      { value: "Intermediate", label: t('skills.intermediate') },
      { value: "Basic", label: t('skills.basic') },
      { value: "Beginner", label: t('skills.beginner') }
    ];

    return (
    <>
      {/* Display Format Selection */}
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="skill-display-format"
            name="skill-display-format-group"
            value={item.displayFormat}
            onChange={(e) => handleChange('displayFormat', e.target.value)}
          >
              <FormControlLabel value="category" control={<Radio />} label={t('skills.displayAscategories')} />
              <FormControlLabel value="individual" control={<Radio />} label={t('skills.displayAsIndividual')} />
          </RadioGroup>
        </FormControl>
      </Grid>

      {/* Conditional Fields */}
      {item.displayFormat === 'individual' ? (
        <>
          {/* Individual Skill Fields */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
                label={t('skills.skillName')}
              value={item.skillName}
              onChange={(e) => handleChange('skillName', e.target.value)}
              sx={components.input.root}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth sx={components.input.root}>
                <InputLabel id={`skill-proficiency-label-${item.id || 'new'}`}>{t('skills.proficiency')}</InputLabel>
              <Select
                labelId={`skill-proficiency-label-${item.id || 'new'}`}
                value={item.proficiency}
                  label={t('skills.proficiency')}
                onChange={(e) => handleChange('proficiency', e.target.value)}
              >
                <MenuItem value=""><em>None</em></MenuItem>
                {SKILL_PROFICIENCY_LEVELS.map((level) => (
                  <MenuItem key={level.value} value={level.value}>{level.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </>
      ) : (
        <>
          {/* Category Skill Fields */}
          <Grid item xs={12}>
            <TextField
              fullWidth
                label={t('skills.skillCategory')}
              value={item.category}
              onChange={(e) => handleChange('category', e.target.value)}
              sx={components.input.root}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline // Allow multiline for better viewing
              rows={3}
                label={t('skills.skillsCommaSeparated')}
              value={item.skills}
              onChange={(e) => handleChange('skills', e.target.value)}
              sx={components.input.root}
            />
          </Grid>
        </>
      )}
    </>
    );
  }
});

export default SkillsCard;
